export default from './move-to-category';



// WEBPACK FOOTER //
// ./app/components/move-to-category/index.js